import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useTranslate } from 'react-admin';
import { PaginationInfo } from '../types';

interface LoadingOverlayProps {
    paginationInfo: PaginationInfo | null;
}

const useStyles = makeStyles({
    overlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 1,
    },
    content: {
        textAlign: 'center',
    },
    spinner: {
        width: '40px',
        height: '40px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #007bff',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 1rem',
    },
    paginationInfo: {
        marginTop: '10px',
        fontSize: '14px',
    },
    progressBarContainer: {
        width: '220px',
        height: '4px',
        backgroundColor: '#f0f0f0',
        borderRadius: '2px',
        margin: '10px auto 0',
        overflow: 'hidden',
    },
    progressBar: {
        height: '100%',
        backgroundColor: '#007bff',
        transition: 'width 0.3s ease',
    },
});

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ paginationInfo }) => {
    const classes = useStyles();
    const t = useTranslate();

    const progressWidth = paginationInfo
        ? paginationInfo.totalItems > 0
            ? `${(paginationInfo.loadedItems / paginationInfo.totalItems) * 100}%`
            : `${Math.min(100, (paginationInfo.requestsCompleted / Math.max(1, paginationInfo.requestsTotal)) * 100)}%`
        : '0%';

    return (
        <Box className={classes.overlay}>
            <Box className={classes.content}>
                <Box className={classes.spinner} />
                <Box>{t('app.common.loadingMapData')}</Box>
                {paginationInfo && (
                    <Box className={classes.paginationInfo}>
                        <Box>
                            {t('app.common.page')} {paginationInfo.currentPage} {t('app.common.of')}{' '}
                            {paginationInfo.totalPages}
                        </Box>
                        <Box>
                            {t('app.common.loaded')} {paginationInfo.loadedItems} {t('app.common.of')}{' '}
                            {paginationInfo.totalItems || '—'} {t('app.common.items')}
                        </Box>
                        <Box>
                            {t('app.common.requests')}: {paginationInfo.requestsCompleted} /{' '}
                            {paginationInfo.requestsTotal} ({paginationInfo.requestsRemaining}{' '}
                            {t('app.common.remaining')})
                        </Box>
                        <Box className={classes.progressBarContainer}>
                            <Box className={classes.progressBar} style={{ width: progressWidth }} />
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};
